/**
 * Accessors for browser-specific functionality without needing a reference DOM in TypeScript.
 * => These can be used in libraries that should be able to run in Node to check we are currently in a browser environment.
 */
export class BrowserUtil {

  /**
   * Checks if the code is running in a browser environment.
   * @returns True if the code is running in a browser environment, false otherwise.
   */
  static isBrowser(): boolean {
    return typeof globalThis !== "undefined" && "window" in globalThis && "localStorage" in globalThis;
  }

  /**
   * Gets the window object as any if this is a browser environment.
   * @returns The window object as any if this is a browser environment, undefined otherwise.
   */
  static getWindow(): any | undefined {
    return this.isBrowser() ? (globalThis as any).window : undefined;
  }

  /**
   * Gets the localStorage object as any if this is a browser environment.
   * NOTE: Use this for string values only, for complex objects, consider using MemoryStorage / SimpleStorage instead.
   * @returns The localStorage object as any if this is a browser environment, undefined otherwise.
   */
  static getLocalStorage(): any | undefined {
    return this.isBrowser() ? (globalThis as any).localStorage : undefined;
  }

  /**
   * Gets the sessionStorage object as any if this is a browser environment.
   * NOTE: Use this for string values only, for complex objects, consider using MemoryStorage / SimpleStorage instead.
   * @returns The sessionStorage object as any if this is a browser environment, undefined otherwise.
   */
  static getSessionStorage(): any | undefined {
    return this.isBrowser() ? (globalThis as any).sessionStorage : undefined;
  }

}
